<template>
	<div class="landenterprise investmentClues ">
		<leftnav class="fl" mkcode="T" itemcode="T-LTQYND"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">{{ curWebsite.type == 5 ? '投资' : "产业" }}动态</span>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<!-- 投资版名字 创新企业融资 -->
							<dynamicNavTZ code="qyndtz"></dynamicNavTZ>
							<!-- 投资时间 -->
							<finacingTime v-on:chooseFinancing="chooseFinancing" dlname="投资" type="day"></finacingTime>
							<dl class="opport-screen bdbe">
								<dt class="fl">土地性质</dt>
								<dd class="fl">
									<span :class="node == '' ? 'a-screen current' : 'a-screen'"
										@click="landClick('')">全部</span>
									<span :class="node == list.value ? 'a-screen current' : 'a-screen'"
										v-for="(list, index) in landPattern" :key="index"
										@click="landClick(list.value)">{{ list.name }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl">投资地点</dt>
								<dd class="fl">
									<span :class="provinceid == 0 ? 'current a-screen' : 'a-screen'"
										@click="provincechoose(0, 'all'); userdata.provinceText = '全国地区';">全国地区</span>
									<span v-for="(item, index) in provincedata" :key="index"
										@click="provincechoose(item.areaId, index); userdata.provinceText = item.areaName"
										:class="item.areaId == provinceid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="citydata.length != 0">
								<dt class="fl">城市地区</dt>
								<dd class="fl">
									<span :class="cityid == 0 ? 'current a-screen' : 'a-screen'"
										@click="choosecity(0, 'all'); userdata.cityText = ''">全部</span>
									<span v-for="(item, index) in citydata" :key="index"
										@click="choosecity(item.areaId, index); cityid = item.areaId; userdata.cityText = item.name"
										:data="item.areaId"
										:class="item.areaId == cityid ? 'a-screen current' : 'a-screen'">{{ item.areaName }}</span>
								</dd>
							</dl>
							<!-- 热点行业 土地版 -->
							<projectIndustry type="land" @getIndustryId="getIndustryId" :token="userdata.token">
							</projectIndustry>
							<!-- 					<dl class="opport-screen bdbe">
								<dt class="fl">热点产业</dt>
								<dd class="fl">
									<span v-for="(item,index) in hotindustry" @click="industrychoose(1,item);"
										:key="index"
										:class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
								<dt class="fl titleop">细分产业</dt>
								<dd class="fl"> 
									<span v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);"
										:key="index"
										:class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
								</dd>
							</dl> -->
						</div>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 表格内容开始 -->
				<div class="whitebox" style="margin-top: 10px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条匹配的拿地动态</p>
					</div>
					<!-- 资本招商线索 -->
					<div class="enterprise_list_box">
						<!-- 标杆企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="enterpristlist.length > 0">
							<tr>
								<th>排名</th>
								<th>行政区</th>
								<th>项目名称</th>
								<th>
									<div @click="tablesort(1);" :class="{ 'td_sortname ': true, 'current': order_field == 1 }">
										总面积(亩)<span :class="order_type == 1 ? 'timesorticon down' : 'timesorticon  up'"></span>
									</div>
								</th>
								<th>土地用途</th>
								<th class="lh24 py-10"><span>土地使用权人 (项目公司)</span></th>
								<th>投资主体 </th>
								<th>投资来源地</th>
								<th>
									<div @click="tablesort(0);" :class="{ 'td_sortname ': true, 'current': order_field == 0 }">
										签订日期<span :class="order_type == 1 ? 'timesorticon down' : 'timesorticon  up'"></span>
									</div>
								</th>
							</tr>
							<tr v-for="(list, i) in enterpristlist" v-if="enterpristlist.length > 0" :key="i">
								<td>{{ 20 * (page - 1) + i + 1 }}</td>
								<td>{{ list.area }}</td>
								<td>{{ list.projectName }}</td>
								<td>{{ list.size }}</td>
								<td>{{ list.purpose }}</td>
								<td><span @click="routerlinkid('/enterprises', list.stockCode)"
										:class="list.stockCode != '' ? 'curp' : ''">{{ list.owner }}</span></td>
								<td><span @click="routerlinkid('/enterprises', list.stockCode)"
										:class="list.stockCode != '' ? 'curp' : ''">{{ list.sourceEnterprise == null ? '-' : list.sourceEnterprise }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.time }}</td>
							</tr>
						</table>


					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="getclue">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	dataInJs
} from "@/utils/city.js";
import projectIndustry from "@/components/inc/project-industry-list.vue"
import { getMonthLength,getCurrentDate,GetPreMonthDay } from '@/utils/common.js'
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'landenterprise',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title:'企业投资拿地动态',
			curWebsite: this.$api.getWebsiteType(),
			notioneditbtn: true, //是否修改notion  
			cityflag: false, //显示城市地图
			usernotionid: 10, //用户选择id 
			notionlist: [], //用户初始概念数据 
			notioncodelist: [], //用户初始概念数据id  
			usernotionlistsave: [], //用户选择的概念列表存储
			usernotionlist: [], //用户选择的概念列表
			total1: 0,
			userdata: {},
			searchtype: 4, //拿地企业投资
			pro: 11,
			node: '',
			liancity: 0, //产业链线索城市
			city4: 1,
			frequency: 1, //融资频次 
			provincedata: [],
			countydata: [],
			citydata: [],
			provinceid: 0,
			cityid: 0,
			countyid: 0,
			industryoptions1: [],
			lianctiy: [],
			cstype: 1, //1供应商 2客户
			supplierlist: [], //供应商列表
			customerlist: [], //客户列表
			ipolist: [], //上市公司列表
			enterpristlist: [],
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10, //最大页数 
			areadata: dataInJs(), //省份城市数据 
			finantime: '',
			finantime2: '',
			landPattern: [],
			order_type: 1, //0降序 1升序
			order_field: 0, //0签定日期 1拿地面积
			industrycode1: "",
			industrycode2: '',
			industryid: 0,
			hotindustry: [],
			hotindustrychild: [],
			isShowFreeUserTips: false,
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();
	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		// this.finantime = '2023-06-01';//每个月都要修改  updatetime
		// this.finantime2 = "2024-05-31";
		this.finantime2 = getCurrentDate();
		this.finantime = GetPreMonthDay(this.finantime2,11);
		this.getlandArea();
		this.getlandPattern();
		// this.gethotindustry();
		this.getclue();
	},
	components: {
		projectIndustry
	},
	methods: {
		landClick(value){
			if(!this.userdata.token){
				this.isShowFreeUserTips =true;
				return;
			}
			this.node = value; 
			this.getclue();
		},
		
		//热点产业筛选
		getIndustryId(id, code1, code2) {
			this.industryid = id;
			this.industrycode1 = code1;
			this.industrycode2 = code2;
			this.getclue();
		},
		//接收子元素传过来的时间
		chooseFinancing(date1, date2) {
			var date2 = date1 + '-' + getMonthLength(date1);
			this.finantime = date1 == 'year' ? this.finantime : date1 + '-1';
			this.finantime2 = date1 == 'year' ? this.finantime2 : date2;
			this.getclue();
		},
		//时间/分数升降序
		tablesort(field) {
			if(!this.userdata.token){
				this.isShowFreeUserTips =true;
				return;
			}
			console.log(field, this.order_field);
			if (field == this.order_field) {
				this.order_type = Math.abs(this.order_type - 1);
			} else {
				this.order_field = field;
			}
			this.getclue();
		},

		choosecityide(art) {
			// console.log(art);
			this.choosecityid(art[0], art[1]);
		},
		//省份城市选择
		provincechoose(id, i) {
			if(!this.userdata.token){
				this.isShowFreeUserTips =true;
				return;
			}
			this.provinceid = id;
			this.cityid = 0;
			this.countyid = 0;
			this.countydata = [];
			if (i != "all" && this.provincedata[i].children != null) {
				this.citydata = this.provincedata[i].children;
			} else {
				this.citydata = [];
			}
			this.page = 1;
			this.getclue();
		},
		choosecity(id, i) {
			//	console.log('choosecity',id);
			this.cityid = id;
			this.countyid = 0;
			if (i != "all" && this.citydata[i].children != null) {
				this.countydata = this.citydata[i].children;
			} else {
				this.countydata = [];
			}
			this.page = 1;
			this.getclue();
		},
		choosecounty(id) {
			//	console.log('choosecity',id);
			this.countyid = id;
			this.page = 1;
			// this.getclue();
		},
		getlandPattern() {
			var _this = this,
				ajaxurl = '';
			ajaxurl = this.$api.enterpriseapi.parameter.landtype();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("拿地类型", res, ajaxurl);
				if (res.data.success) {
					_this.landPattern = res.data.list;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		getlandArea() {
			var _this = this,
				ajaxurl = '';
			ajaxurl = this.$api.enterpriseapi.parameter.landarea();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log("拿地区域", res, ajaxurl);
				if (res.data.success) {
					_this.provincedata = res.data.list;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取产业链/区域/融资企业招商线索
		getclue(pages) {
			var _this = this,
				ajaxurl = '';
			this.bus.$emit('loading', true);
			this.page = pages ? pages : 1;
			var landtype = this.splicing('landType', this.node);
			var industryja1 = this.splicing('industry1', this.industrycode1);
			var industryja2 = this.splicing('industry2', this.industrycode2);
			var orderfield = this.splicing('orderField', this.order_field);
			var ordertype = this.splicing('orderType', this.order_type);
			var date = "", date2 = "";
			var date1 = this.splicing('date1', this.finantime);
			var date2 = this.splicing('date2', this.finantime2);

			ajaxurl = this.$api.enterpriseapi.land.list() + '?page=' + this.page + orderfield + ordertype + date1 + date2 + landtype + '&province=' + this.provinceid + '&city=' + this.cityid + industryja1 + industryja2;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(_this.usernotionlist,_this.notionlist);
				console.log("拿地列表", res, ajaxurl);
				if (res.data.success) {
					_this.enterpristlist = res.data.list;
					_this.bus.$emit('loading', false);
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		pageHandler: function (page) {
			this.page = page;
			this.getclue(page);
		},
	},
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}</style>